import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const close = useCallback(() => setSidebarOpen(false), []);

  // Cierra el drawer al navegar.
  useEffect(() => {
    close();
  }, [location.pathname, close]);

  // Cierra con Escape.
  useEffect(() => {
    if (!sidebarOpen) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") close();
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [sidebarOpen, close]);

  // Body scroll lock cuando el drawer está abierto en mobile.
  useEffect(() => {
    if (!sidebarOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [sidebarOpen]);

  return (
    <div className={`app ${sidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar onNavigate={close} />
      {sidebarOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Cerrar menú"
          onClick={close}
        />
      )}
      <main className="main">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <div className="page-body">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
